"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.joinParametersToTealiumArray = joinParametersToTealiumArray;
/**
 * Nimmt eine Liste von Objekten (z.B. `ProductParameter[]`) und joined
 * die Werte Semikolon-separiert in ein einzelnes `ProductParameter` Objekt.
 *
 * Beispiel:
 *
 * Input:
 *
 * ```
 * [
 *   {
 *     product_name: "prepaid-basic-s",
 *     product_basic_price: "10.00",
 *     product_id: "12345",
 *   },
 *   {
 *     product_name: "datenflat",
 *     product_basic_price: "5.00",
 *     product_discount: "1.00",
 *     product_id: "17",
 *   }
 * ]
 * ```
 *
 * Output:
 * ```
 * {
 *   product_name: "prepaid-basic-s;datenflat",
 *   product_basic_price: "10.00;5.00",
 *   product_id: "12345;17",
 *   product_discount: ";1.00",
 * }
 * ```
 *
 * @category Utils
 * @param objects
 */
function joinParametersToTealiumArray(objects) {
    const result = {};
    const allKeys = objects.flatMap((o) => Object.keys(o));
    const keys = Array.from(new Set(allKeys));
    keys.forEach((key) => {
        const value = objects.map((o) => { var _a; return (_a = o[key]) !== null && _a !== void 0 ? _a : ''; }).join(';');
        // only add value to result if it contains any other character than semicolon
        if (/(?=.*?[^;])/.test(value)) {
            result[key] = value;
        }
    });
    return result;
}
